module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'one': _vm.one,
      'two': _vm.two,
      'three': _vm.three,
      'failed': _vm.failed
    },
    attrs: {
      "id": "loading-block"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-edb89dce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingBlock.vue
// module id = 470
// module chunks = 2